'use client'

import { Badge, Cell, Image, Rating, Spacer } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { UserImage } from '@marketplace-web/common-components/user-image-ui'
import { MEMBER_PROFILE_URL } from 'constants/routes'
import { UserTitle } from '@marketplace-web/common-components/user-title-ui'

type Props = {
  login: string
  id: number
  averageRating: number
  ratingCount: number
  isBusiness: boolean
  photoUrl?: string | null
  businessAccountName?: string
  showChevron?: boolean
  testId?: string
}

const MAX_RATING = 5

const UserCell = ({
  login,
  photoUrl,
  id,
  averageRating,
  ratingCount,
  isBusiness,
  businessAccountName,
  showChevron = false,
  testId,
}: Props) => {
  const translate = useTranslate()

  return (
    <Cell
      prefix={<UserImage src={photoUrl} styling={Image.Styling.Circle} size={Image.Size.Large} />}
      title={
        <UserTitle
          badgeTitle={translate('business.title')}
          businessAccountName={businessAccountName}
          login={login}
          isBusiness={isBusiness}
          isBody
          isBottomLoginHidden
          isBadgeHidden
          truncate
        />
      }
      url={MEMBER_PROFILE_URL(id)}
      type={Cell.Type.Navigating}
      chevron={showChevron}
      testId={testId}
    >
      <Rating
        aria={{
          'aria-label': averageRating
            ? translate('user.a11y.rating', { rating: averageRating, max_rating: MAX_RATING })
            : '',
        }}
        value={averageRating}
        text={ratingCount}
        size={Rating.Size.Small}
        emptyStateText={translate('user.feedback.no_reviews')}
        testId={testId ? `${testId}-rating` : undefined}
      />
      {isBusiness && (
        <>
          <Spacer size={Spacer.Size.Small} />
          <Badge
            content={translate('business.title')}
            testId={testId ? `${testId}-business-badge` : undefined}
          />
        </>
      )}
    </Cell>
  )
}

export default UserCell
